// extracted by mini-css-extract-plugin
export var hideEditor = "_jb-2";
export var infoIcon = "_jb-3";
export var label = "_jb-1";
export var labelContainer = "_jb-0";
export var readonlyText = "_jb-4";